import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ProductCategoryService } from '../services/productcategory.service';
import { ProductSpecpageModel } from '../models/product.specpage.model';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-productpdf',
  templateUrl: './productpdf.component.html',
  styleUrls: ['./productpdf.component.css']
})
export class ProductpdfComponent implements OnInit {
  productId: number;
  i = 0;
  casePack: string;
  newIndex = 0;
  nomenclature = '';
  casepacks = Array<string>();
  baseUrl = environment.baseUrl;

  specpage: ProductSpecpageModel[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ProductCategoryService,
  ) {
    this.productId = this.route.snapshot.params.productId;
    this.casePack = this.route.snapshot.params.casePack;

  }

  ngOnInit(): void {
    //console.log('test');
    //console.log(this.route);

    this.service.getPDFPageData(this.productId, this.casePack)
    .subscribe(
      (data =>
      {
         this.specpage = data;
         this.nomenclature = this.specpage[0].nomenclature;
         //console.log(this.specpage);


      }),
      (error =>
      {
        //console.log(error);
        this.nomenclature = '';
      })
    );



  }
  public captureScreen(){
    let DATA = document.getElementById('html2canvas-container');

    html2canvas(DATA, {allowTaint: true, useCORS: true}).then(canvas => {

      var imgData = canvas.toDataURL('image/png');

      /*
      Here are the numbers (paper width and height) that I found to work.
      It still creates a little overlap part between the pages, but good enough for me.
      if you can find an official number from jsPDF, use them.
      */
      var imgWidth = 450;
      var pageHeight = 750;
      var imgHeight = canvas.height * imgWidth / canvas.width;
      var heightLeft = imgHeight;

      var doc = new jsPDF('p', 'px');
      var position = 0;

      doc.addImage(canvas, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      doc.save( 'file.pdf');

    });
    }

  SwitchIndex(event: any){
    this.i = event.target.value;
    //console.log(this.specpage[this.i]);
    //console.log(this.i);
  }
}
